import { useTranslation } from 'react-i18next';
import type { AppToastVariant } from './appToast.types';
import {
  SCard,
  SCloseButton,
  SIconWrap,
  SMessage,
  STextCol,
  STitle,
  variantIconBg,
} from './ToastNotification.styles';

const variantIcon: Record<AppToastVariant, React.ReactElement> = {
  success: (
    <svg width="15" height="11" viewBox="0 0 15 11" fill="none" aria-hidden>
      <path
        d="M1.5 5L5.5 9L13.5 1"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  error: (
    <svg width="13" height="13" viewBox="0 0 13 13" fill="none" aria-hidden>
      <path d="M6.5 1v6M6.5 10v1.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
    </svg>
  ),
};

export type ToastNotificationProps = {
  variant: AppToastVariant;
  title?: string;
  message: string;
  visible?: boolean;
  onRequestClose: () => void;
};

export function ToastNotification({
  variant,
  title,
  message,
  visible = true,
  onRequestClose,
}: ToastNotificationProps) {
  const { t } = useTranslation();

  return (
    <SCard role="alert" aria-live="polite" $visible={visible}>
      <SIconWrap $bg={variantIconBg[variant]}>{variantIcon[variant]}</SIconWrap>
      <STextCol>
        {title ? <STitle>{title}</STitle> : null}
        {title ? <SMessage>{message}</SMessage> : <STitle>{message}</STitle>}
      </STextCol>
      <SCloseButton type="button" onClick={onRequestClose} aria-label={t('close')}>
        <svg width="12" height="12" viewBox="0 0 10 10" fill="none" aria-hidden>
          <path
            d="M1 1L9 9M9 1L1 9"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
        </svg>
      </SCloseButton>
    </SCard>
  );
}
